import { Util } from './util';
import { Conn_Db } from '../models/datapoint/conn_db';
import { Attribute } from '../models/domain/attribute';

export class WrapperUtil {
    private static instance: WrapperUtil;

    static getInstance() {
        if (!WrapperUtil.instance) {
            WrapperUtil.instance = new WrapperUtil();
        }

        return WrapperUtil.instance;
    }

    util: Util;

    /**
     * WrapperUtil is a singleton class, so use WrapperUtil.getInstance() method instead of creating new WrapperUtil().
     */
    private constructor() {
        this.util = Util.getInstance();
    }

    doSearch(searchText: string, list, type) {
        let itemList = [];
        let searchTextUC = searchText.toUpperCase();

        itemList.splice(0, itemList.length);

        for (let i = 0; i < list.length; i++) {

            let item = list[i];

            if (type == "layer") {
                if (searchTextUC != "") {
                    if (item.layer.nm.toUpperCase().indexOf(searchTextUC) == -1)
                        continue;
                }
            }

            if (type == "database") {

                if (searchTextUC != "") {
                    if (item.name.toUpperCase().indexOf(searchTextUC) == -1)
                        continue;
                }
            }

            itemList.push(JSON.parse(JSON.stringify(item)));
        }

        return itemList;
    }
    /****** OBJECTS ***********/

    updateName(objectWrapper) {
        if (!objectWrapper) return;

        let paramValue = '$' + objectWrapper.code + '_' + objectWrapper.fldr_Cd + '_' + objectWrapper.databaseWrapper.code + '_' + objectWrapper.aliasNm + '_' + objectWrapper.name;
        objectWrapper.setParamNm(paramValue.toUpperCase());
    }

    updateSchemaParamName(objectWrapper, conn_Db_New) {
        if (!objectWrapper || !conn_Db_New) return;

        return '$SC' + '_' + objectWrapper.databaseWrapper.code + '_' + objectWrapper.aliasNm + '_' + objectWrapper.name + '_' + conn_Db_New.nm + "_" + conn_Db_New.schemaNm;

        /*return '$SC' + objectWrapper.code + '_' + objectWrapper.databaseWrapper.code + '_' + objectWrapper.aliasNm + '_' + objectWrapper.name + '_' + conn_Db_New.nm +"_"+ conn_Db_New.schemaNm;*/
    }

    updateDbParamNm(objectWrapper, conn_Db_New) {
        if (!objectWrapper || !conn_Db_New) return;

        return "$DB_" + objectWrapper.databaseWrapper.code + "_" + objectWrapper.aliasNm + "_" + objectWrapper.name.toUpperCase() + "_" + conn_Db_New.nm;

        /*return "$DB_" + objectWrapper.code + "_" + objectWrapper.aliasNm + "_" + angular.uppercase(objectWrapper.name) + "_" + angular.uppercase(conn_Db_New.nm);*/
    }

    /*********** Downstream chain actions *************/
    downStreamObj_Ids: Array<number>
    downStreamRename(oldname, newName, srt_Order, transformWrapper, designWrapper) {
        this.downStreamObj_Ids = new Array<number>();
        this.setDownStreamObj_Ids(transformWrapper.obj_Id, designWrapper.dxMp_Fwd_Lnks);

        for (let i = 0; i < this.downStreamObj_Ids.length; i++) {
            let transformWrapper = designWrapper.getTransformWrapper(this.downStreamObj_Ids[i]);
            transformWrapper.downStreamRename(oldname, newName, 0);
        }
    }

    rename(regex, newName, value) {
        return value.replace(regex, newName);
    }

    setDownStreamObj_Ids(transform_Id, dxMp_Fwd_Lnks) {
        for (let i = 0; i < dxMp_Fwd_Lnks.length; i++) {
            if (dxMp_Fwd_Lnks[i].obj_Id == transform_Id) {
                this.downStreamObj_Ids.push(dxMp_Fwd_Lnks[i].fwd_Lnk_Obj_Id);
                this.setDownStreamObj_Ids(dxMp_Fwd_Lnks[i].fwd_Lnk_Obj_Id, dxMp_Fwd_Lnks);
            }
        }
    }

    /********** AddCarryForwardAttributes ***********/
    addCarryForwardAttributes(transformWrapper, carryForwardAttributes, emptyAttribute) {
        for (let i = 0; i < carryForwardAttributes.length; i++) {
            let transformObject = carryForwardAttributes[i]

            for (let j = 0; j < transformObject.items.length; j++) {
                let attributeObject = transformObject.items[j];

                if (attributeObject.checked) {
                    let attributeNew = new Attribute();

                    attributeNew.obj_Id = transformWrapper.obj_Id;
                    attributeNew.dxMp_Id = transformWrapper.dxMp_Id;
                    attributeNew.attr_Id = transformWrapper.attributes.length + 1;
                    attributeNew.attrNm = this.util.getNewName(attributeObject.text, transformWrapper.subNames);
                    attributeNew.attrExprVal = attributeObject.name;
                    attributeNew.valid_Cd = '0';
                    attributeNew.attrDTyp_Id = attributeObject.attrDTyp_Id;
                    attributeNew.attrPrec = attributeObject.attrPrec;
                    attributeNew.attrScale = attributeObject.attrScale;
                    attributeNew.srt_Order = transformWrapper.attributes.length;

                    transformWrapper.attributes.push(attributeNew);
                }
            }
        }
    }

    /********** Designlet outputMapper Attributes ***********/
    addOutputMapperAttributes(transformWrapper, carryForwardAttributes, emptyAttribute, DIDatabases) {
        let lnk_Attr_Ids = [];
        let subNames = []

        for (let i = 0; i < transformWrapper.attributes.length; i++) {
            let attribute = transformWrapper.attributes[i];

            if (attribute.lnk_Attr_Id == -1) {
                subNames[attribute.attrNm] = attribute;
            } else {
                lnk_Attr_Ids[attribute.lnk_Attr_Id] = attribute;
            }
        }

        for (let i = 0; i < carryForwardAttributes.length; i++) {
            let transformObject = carryForwardAttributes[i];
            let attribute: Attribute;

            for (let j = 0; j < transformObject.items.length; j++) {
                let attributeObject = transformObject.items[j];

                if (attributeObject.checked) {

                    if (lnk_Attr_Ids[attributeObject.attr_Id]) continue;

                    attribute = subNames[attributeObject.text];
                    if (!attribute) {
                        attribute = new Attribute();

                        let outAttribute = transformWrapper.outputCarryForwardAttributesHMapIds[transformObject.obj_Id + '-' + attributeObject.attr_Id];
                        if (outAttribute == null) continue;

                        attribute.dxMp_Id = transformWrapper.dxMp_Id;
                        attribute.obj_Id = transformWrapper.obj_Id;
                        // attribute.attr_Id = getNewSub_Id(transformWrapper);
                        attribute.attrNm = this.util.getNewName(outAttribute.attrNm, transformWrapper.subNames);

                        attribute.attrDTyp_Id = DIDatabases.equivalentDbTyp_Id(transformObject.dbTyp_Id, outAttribute.attrDTyp_Id, transformWrapper.dbTyp_Id);

                        attribute.attrPrec = outAttribute.attrPrec;
                        attribute.attrScale = outAttribute.attrScale;

                        attribute.srt_Order = transformWrapper.attributes.length;

                        attribute.lnk_Obj_Id = transformObject.obj_Id;
                        attribute.lnk_Attr_Id = attributeObject.attr_Id;

                        attribute.valid_Cd = '0';
                        attribute.error_Msg = '';

                        transformWrapper.attributes.push(attribute);
                        transformWrapper.subNames.push(attribute.attrNm.toUpperCase());

                    } else {
                        attribute.lnk_Obj_Id = transformObject.obj_Id;
                        attribute.lnk_Attr_Id = attributeObject.attr_Id;

                        attribute.valid_Cd = '0';
                        attribute.error_Msg = '';
                    }
                } else {
                    attribute = lnk_Attr_Ids[attributeObject.attr_Id];
                    if (!attribute) continue;

                    attribute.lnk_Obj_Id = -1;
                    attribute.lnk_Attr_Id = -1;

                }
            }
        }
    }

	/*addVenn_Grp_Attrs(transformWrapper, carryForwardLAttributes, 
			lAttributeEmpty, venn_Grp_AttrEmpty ) {
		let venn_Grp_AttHMapIds = [];
		
		for( let h = 0; h < transformWrapper.vennGroups.length; h++ ) {
			let vennGroup = transformWrapper.vennGroups[h];
			
			for( let i = 0; i < vennGroup.venn_Grp_Attrs.length; i++ ) {
				let venn_Grp_Attr = vennGroup.venn_Grp_Attrs[i];
				venn_Grp_AttHMapIds[venn_Grp_Attr.lnk_Obj_Id + '-' + venn_Grp_Attr.lnk_Attr_Id] = venn_Grp_Attr.srt_Order;
			}
			
			//vennGroup.venn_Grp_Attrs[i].obj_Id + '-' + carryForwardLAttributes[i].obj_Id + '-' + 
			for( let i = 0; i < carryForwardLAttributes.length; i++ ) {
				let transformObject = carryForwardLAttributes[i];
				if( transformObject.fwd_Lnk_Grp_Id != vennGroup.venn_Grp.venn_Grp_Id ) continue;
				
				for( let j = 0; j < transformObject.items.length; j++ ) {
					let attributeObject = transformObject.items[j];
					
					if( attributeObject.checked ) {
						if( venn_Grp_AttHMapIds[transformObject.obj_Id + '-' + attributeObject.attr_Id] != null ) {
							venn_Grp_AttHMapIds[transformObject.obj_Id + '-' + attributeObject.attr_Id] = attributeObject.text;
							continue;
						}
						
						let venn_Grp_AttrNew = angular.copy(venn_Grp_AttrEmpty);
						
						venn_Grp_AttrNew.dxMp_Id = transformWrapper.designWrapper.obj_Id;
						venn_Grp_AttrNew.lnk_Attr_Id = attributeObject.attr_Id;
						venn_Grp_AttrNew.lnk_Obj_Id = attributeObject.obj_Id;
						venn_Grp_AttrNew.venn_Grp_Id = vennGroup.venn_Grp.venn_Grp_Id;
						venn_Grp_AttrNew.venn_Inst_Id = transformWrapper.obj_Id;
						venn_Grp_AttrNew.srt_Order = vennGroup.venn_Grp_Attrs.length;
				
						vennGroup.venn_Grp_Attrs.push(venn_Grp_AttrNew);
						
						venn_Grp_AttHMapIds[transformObject.obj_Id + '-' + attributeObject.attr_Id] = attributeObject.text;
					} else {
						if( venn_Grp_AttHMapIds[transformObject.obj_Id + '-' + attributeObject.attr_Id] == null )
							continue;
						
						for( let k = 0; k < vennGroup.venn_Grp_Attrs.length; k++ ) {
							let venn_Grp_Attr = vennGroup.venn_Grp_Attrs[k];
							if( venn_Grp_Attr.lnk_Obj_Id == transformObject.obj_Id &&
									venn_Grp_Attr.lnk_Attr_Id == attributeObject.attr_Id ) {
								vennGroup.venn_Grp_Attrs.splice(k, 1);
								k--;
							}
						}
					}
				}
			}
			
			for( let i = 0; i < vennGroup.venn_Grp_Attrs.length; i++ ) {
				vennGroup.venn_Grp_Attrs[i].srt_Order = i;
			}
			
			// Add lAttibutes
			if( vennGroup.venn_Grp.srt_Order == 0 ) {
				let lAttributesHMapIds = [];
				
				for( let i = 0; i < transformWrapper.lAttributes.length; i++ ) {
					lAttributesHMapIds[transformWrapper.lAttributes[i].lnk_Obj_Inst_Id + '-' + transformWrapper.lAttributes[i].lnk_Attr_Id] = transformWrapper.lAttributes[i];
				}
				
				transformWrapper.lAttributes.splice(0, transformWrapper.lAttributes.length);
				
				for( let i = 0; i < vennGroup.venn_Grp_Attrs.length; i++ ) {
					
					let venn_Grp_Attr = vennGroup.venn_Grp_Attrs[i];
					
					let lAttribute = lAttributesHMapIds[venn_Grp_Attr.lnk_Obj_Id + '-' + venn_Grp_Attr.lnk_Attr_Id]
					
					if( lAttribute != null ) {
						transformWrapper.lAttributes.push(lAttribute);
						continue;
					}
					
					let lAttrNm = venn_Grp_AttHMapIds[venn_Grp_Attr.lnk_Obj_Id + '-' + venn_Grp_Attr.lnk_Attr_Id]
					
					let lAttributeNew = angular.copy(lAttributeEmpty);
					
					lAttributeNew.dxMp_Id = transformWrapper.designWrapper.obj_Id;
					
					lAttributeNew.obj_Id = transformWrapper.obj_Id;
					lAttributeNew.lAttr_Id = getNewLAttr_Id(transformWrapper);
					lAttributeNew.lAttrNm = util.getNewName(lAttrNm, transformWrapper.subNames);
					
					lAttributeNew.lnk_Attr_Id = venn_Grp_Attr.lnk_Attr_Id;
					lAttributeNew.lnk_Obj_Inst_Id = venn_Grp_Attr.lnk_Obj_Id;
					
					lAttributeNew.srt_Order = transformWrapper.lAttributes.length;
					
					transformWrapper.lAttributes.push(lAttributeNew);
				}
				
				for( let i = 0; i < transformWrapper.lAttributes.length; i++ ) {
					transformWrapper.lAttributes[i].srt_Order = i;
				}
			}
		
		}
	}*/

    /***************** VENN GROUPS **********/
    setNewVenn_Grp_Id(objectWrapper, vennGroups) {
        objectWrapper.newVenn_Grp_Id = -1;

        for (let i = 0; i < vennGroups.length; i++) {
            if (objectWrapper.newVenn_Grp_Id < vennGroups[i].venn_Grp.venn_Grp_Id) {
                objectWrapper.newVenn_Grp_Id = vennGroups[i].venn_Grp.venn_Grp_Id;
            }
        }
    }

    getNewVenn_Grp_Id(objectWrapper) {
        if (objectWrapper.newVenn_Grp_Id == -1) {
            objectWrapper.newVenn_Grp_Id = 0;
            return objectWrapper.newVenn_Grp_Id;
        }

        return ++objectWrapper.newVenn_Grp_Id;
    }

    setNewMJnr_Inst_Cnd_Id(objectWrapper, mJnr_Inst_Cnds) {
        objectWrapper.newMJnr_Inst_Cnd_Id = -1;

        for (let i = 0; i < mJnr_Inst_Cnds.length; i++) {
            if (objectWrapper.newMJnr_Inst_Cnd_Id < mJnr_Inst_Cnds[i].mJnr_Inst_Cnd_Id) {
                objectWrapper.newMJnr_Inst_Cnd_Id = mJnr_Inst_Cnds[i].mJnr_Inst_Cnd_Id;
            }
        }
    }

    getNewMJnr_Inst_Cnd_Id(objectWrapper) {
        if (objectWrapper.newMJnr_Inst_Cnd_Id == -1) {
            objectWrapper.newMJnr_Inst_Cnd_Id = 0;
        }

        return ++objectWrapper.newMJnr_Inst_Cnd_Id;
    }

    /******************** ATTRIBUTES ****************/
    conn_DbEmpty = null;
    parameterEmpty = null;
    expressionEditorFunctions = null;
    lAttributeEmpty = null;

    addAttribute(attribute, attributes, objectWrapper) {
        attributes.push(attribute);

        if (objectWrapper.subNames.indexOf(attribute.attrNm) == -1)
            objectWrapper.subNames.push(attribute.attrNm.toUpperCase());
    }


    resetAttributesSrt_Order(attributes, index: number = 0) {
        //	if( index == undefined )  index = 0;

        for (let i = index; i < attributes.length; i++) {
            attributes[i].srt_Order = i;
        }
    }

    upAttributes(selectedAttributes, attributes, objectWrapper) {
        for (let i = 0; i < selectedAttributes.length; i++) {
            let index = attributes.indexOf(selectedAttributes[i]);
            if (index <= 0) continue;

            let splicedAttributes = attributes.splice(index, 1);
            attributes.splice(index - 1, 0, splicedAttributes[0]);
        }

        this.resetAttributesSrt_Order(attributes);
    }

    downAttributes(selectedAttributes, attributes, objectWrapper) {
        for (let i = selectedAttributes.length - 1; i >= 0; i--) {
            let index = attributes.indexOf(selectedAttributes[i]);
            if (index == -1 || index == (attributes.length - 1)) continue;

            let splicedAttributes = attributes.splice(index, 1);
            attributes.splice(index + 1, 0, splicedAttributes[0]);
        }

        this.resetAttributesSrt_Order(attributes);
    }


    //	LAttributes

    setNewLAttr_Id(objectWrapper, lAttributes) {
        objectWrapper.newLAttr_Id = -1;
        for (let i = 0; i < lAttributes.length; i++) {
            if (objectWrapper.newLAttr_Id < lAttributes[i].lAttr_Id) {
                objectWrapper.newLAttr_Id = lAttributes[i].lAttr_Id;
            }
        }
    }

    getNewLAttr_Id(objectWrapper) {
        if (objectWrapper.newLAttr_Id == -1) {
            objectWrapper.newLAttr_Id = objectWrapper.obj_Id * 10000 - 1;
        }

        return ++objectWrapper.newLAttr_Id;
    }



    addLAttribute(lAttribute, lAttributes, objectWrapper) {
        lAttributes.push(lAttribute);

        if (objectWrapper.subNames.indexOf(lAttribute.lAttrNm) == -1)
            objectWrapper.subNames.push(lAttribute.lAttrNm.toUpperCase());
    }

    getLAttribute(lAttr_Id, lAttributes) {

        for (let i = 0; i < lAttributes.length; i++) {
            if (lAttributes[i].lAttr_Id == lAttr_Id) {
                return lAttributes[i];
            }
        }

        return null;
    }


    /* Connection Database Utils */
    setNewConn_Db_Id(objectWrapper, conn_Dbs) {
        objectWrapper.newConn_Db_Id = -1;

        for (let i = 0; i < conn_Dbs.length; i++) {
            if (objectWrapper.newConn_Db_Id < conn_Dbs[i].conn_Db_Id) {
                objectWrapper.newConn_Db_Id = conn_Dbs[i].conn_Db_Id;
            }
        }
    }

	/*getNewConn_Db_Id( objectWrapper, conn_Dbs ) {
		if( objectWrapper.newConn_Db_Id == -1 ) {
			objectWrapper.newConn_Db_Id = objectWrapper.obj_Id * 1000 - 1;
		}
			
		return ++objectWrapper.newConn_Db_Id;
	}
	*/

    packConn_DBNms(objectWrapper, conn_Dbs) {
        objectWrapper.conn_DbNms = [];

        for (let i = 0; i < conn_Dbs.length; i++) {
            objectWrapper.conn_DbNms.push(conn_Dbs[i].nm.toUpperCase());
        }
    }

    packConnDBDatabaseNm(objectWrapper, conn_Dbs) {
        objectWrapper.databaseNms = [];

        for (let i = 0; i < conn_Dbs.length; i++) {
            objectWrapper.databaseNms.push(conn_Dbs[i].databaseNm);
        }
    }

    packConnDBSchemaNm(objectWrapper, conn_Dbs) {
        objectWrapper.schemaNms = [];

        for (let i = 0; i < conn_Dbs.length; i++) {
            objectWrapper.schemaNms.push(conn_Dbs[i].schemaNm);
        }
    }

    packConnDBParamNm(objectWrapper, conn_Dbs) {
        objectWrapper.subNames = [];

        for (let i = 0; i < conn_Dbs.length; i++) {
            objectWrapper.subNames.push(conn_Dbs[i].dbParamNm);
        }
    }

	/*addConn_Db( conn_Db, conn_Dbs, objectWrapper ) {
		conn_Dbs.push(conn_Db);

		if( objectWrapper.conn_DbNms.indexOf(conn_Db.nm) == -1 )
			objectWrapper.conn_DbNms.push(conn_Db.nm);
		
		if( objectWrapper.databaseNms.indexOf(conn_Db.databaseNm) == -1 )
			objectWrapper.databaseNms.push(conn_Db.databaseNm);
			
		if( objectWrapper.schemaNms.indexOf(conn_Db.schemaNm) == -1 )
			objectWrapper.schemaNms.push(conn_Db.schemaNm);
		
		if( objectWrapper.subNames.indexOf(conn_Db.dbParamNm) == -1 )
			objectWrapper.subNames.push(conn_Db.dbParamNm);
	}*/

	/*addConnDBAt( connDB, conn_Dbs, index, objectWrapper ) {
		if( index == -1 ) {
			return;
		}
		
		objectWrapper.conn_Dbs.splice( index, 0, connDB );
		
		resetConnDBSrt_Order( conn_Dbs, index );
		
		if( objectWrapper.conn_DbNms.indexOf(connDB.nm) == -1 )
			objectWrapper.conn_DbNms.push(connDB.nm);
		if( objectWrapper.schemaNms.indexOf(connDB.schemaNm) == -1 )
			objectWrapper.schemaNms.push(connDB.schemaNm);
		if( objectWrapper.subNames.indexOf(connDB.dbParamNm) == -1 )
			objectWrapper.subNames.push(connDB.dbParamNm);
	}*/

    getConnDB(conn_Db_Id, conn_Dbs) {
        for (let i = 0; i < conn_Dbs.length; i++) {
            if (conn_Dbs[i].conn_Db_Id == conn_Db_Id) {
                return conn_Dbs[i];
            }
        }

        return null;
    }
    /*getNewConnDB_Id( objectWrapper ) {
           return ++objectWrapper.newConn_Db_Id;
       }*/


    deleteConnDB(selectedConn_Dbs, conn_Dbs) {
        let deletedConnDB = [];

        for (let i = selectedConn_Dbs.length - 1; i >= 0; i--) {
            let index = conn_Dbs.indexOf(selectedConn_Dbs[i]);
            if (index == -1) continue;

            let splicedConnDB = conn_Dbs.splice(index, 1);
            deletedConnDB.push(splicedConnDB[0]);
        }

        // resetConnDBSrt_Order(conn_Dbs);

        return deletedConnDB;
    }

    /*resetConnDBSrt_Order( conn_Dbs, index ) {
        if( index == undefined ) 
            index = 0;
    	
        for( let i = index; i < conn_Dbs.length; i++ ) {
            conn_Dbs[i].srt_Order = i;				
        }
    }*/

    /*pasteConnDB( copiedConnDB, conn_Dbs, index, objectWrapper,emptyConnDb ) {
        if( copiedConnDB.length == 0 ) return;
    	
        for( let i = 0; i < copiedConnDB.length; i++ ) {
            let connDB = cloneConnDB(copiedConnDB[i],emptyConnDb);
        	
            connDB.conn_Db_Id = getNewConnDB_Id(objectWrapper);
            connDB.nm = util.getNewName( 'DATABASE_NAME_1', objectWrapper.conn_DbNms );
            connDB.schemaNm = util.getNewName( 'SCHEMA_NAME_1', objectWrapper.schemaNms );
            connDB.dbParamNm = util.getNewName( 'PARAM_NAME_1', objectWrapper.subNames );	
        	
            if( index == -1 ) {
                connDB.srt_Order = conn_Dbs.length;
                addConnDB( connDB, conn_Dbs, objectWrapper );	    			
            } else {
                connDB.srt_Order = index;
                addConnDBAt( connDB, conn_Dbs, index + 1, objectWrapper );
            }
        }
    }*/

    cloneConnDB(conn_Db, emptyConn_Db) {
        if (!emptyConn_Db) return;

        let connDBNew = new Conn_Db();

        connDBNew.conn_Db_Id = conn_Db.conn_Db_Id;
        connDBNew.nm = conn_Db.nm;
        connDBNew.databaseNm = conn_Db.databaseNm;
        connDBNew.schemaNm = conn_Db.schemaNm;
        connDBNew.dbParamNm = conn_Db.dbParamNm;
        connDBNew.srt_Order = conn_Db.srt_Order;


        return connDBNew;

    }

    /*upDatabase( selectedConn_Dbs, conn_Dbs, objectWrapper ) {
    	
        for( let i = 0; i < selectedConn_Dbs.length; i++ ) {
            let index = conn_Dbs.indexOf( selectedConn_Dbs[i] );
            if( index <= 0 ) continue;
        	
            let splicedConnDB = conn_Dbs.splice( index, 1 );
            conn_Dbs.splice( index-1, 0, splicedConnDB[0] );
        }
    	
        resetConnDBSrt_Order(conn_Dbs);
    }*/

    /*downDatabase( selectedConn_Dbs, conn_Dbs, objectWrapper ) {
        for( let i = selectedConn_Dbs.length - 1; i >= 0; i-- ) {
            let index = conn_Dbs.indexOf( selectedConn_Dbs[i] );
            if( index == -1 || index == (conn_Dbs.length-1) ) continue;
        	
            let splicedConnDB = conn_Dbs.splice( index, 1 );
            conn_Dbs.splice( index + 1, 0, splicedConnDB[0] );
        }
    	
        resetConnDBSrt_Order(conn_Dbs);
    }	*/

    /** Parameters **/


    /* addParameter( parameter, parameters, objectWrapper ){
        parameters.push(parameter);
	
        if( objectWrapper.subNames.indexOf(parameter.nm) == -1 )
            objectWrapper.subNames.push(parameter.nm);
     }*/

    getParameter(param_Id, parameters) {
        for (let i = 0; i < parameters.length; i++) {
            if (parameters[i].param_Id == param_Id) {
                return parameters[i];
            }
        }

        return null;
    }


    /*deleteParameters( selectedParameters, parameters ) {
        let deletedParameters = [];
    	
        for( let i = selectedParameters.length - 1; i >= 0; i-- ) {
            let index = parameters.indexOf( selectedParameters[i] );
            if( index == -1 ) continue;
        	
            let splicedParameters = parameters.splice( index, 1 );
            deletedParameters.push( splicedParameters[0] );
        }
    	
        resetParametersSrt_Order(parameters);
    	
        return deletedParameters;
    }*/

    pasteSqlParameters(copiedParameters, parameters, index, objectWrapper) {
        if (copiedParameters.length == 0) return;

        for (let i = 0; i < copiedParameters.length; i++) {
            let parameter = this.cloneParameter(copiedParameters[i]);

            // parameter.param_Id = getNewSub_Id(objectWrapper);
            parameter.nm = this.util.getNewName(parameter.nm, objectWrapper.subNames);

            if (index == -1) {
                parameter.srt_Order = parameters.length;
                // addParameter(parameter, parameters, objectWrapper);
            } else {
                parameter.srt_Order = index;
                this.addParameterAt(parameter, parameters, index + 1, objectWrapper);
            }
        }
    }

    /*pasteParameters( copiedParameters, parameters, index, objectWrapper,emptyParam ) {
        if( copiedParameters.length == 0 ) return;
    	
        for( let i = 0; i < copiedParameters.length; i++ ) {
            let parameter = cloneParameter(copiedParameters[i],emptyParam);
        	
            parameter.param_Id = getNewSub_Id(objectWrapper);
            parameter.nm = util.getNewName( parameter.nm, objectWrapper.subNames );
            parameter.paramNm = util.getNewName( parameter.paramNm, objectWrapper.subNames );
        	
            if( index == -1 ) {
                parameter.srt_Order = parameters.length;
                addParameter( parameter, parameters, objectWrapper );	    			
            } else {
                parameter.srt_Order = index;
                addSqlParameterAt( parameter, parameters, index + 1, objectWrapper );
            }
        }
    }*/

    //TBD packSubNames(objectWrapper, parameters, sqlParamaters) {
    //     objectWrapper.subNames = [];

    //     for (let i = 0; i < parameters.length; i++) {
    //         objectWrapper.subNames.push(parameters[i].paramNm)
    //     }

    //     if (sqlParamaters) {
    //         for (let i = 0; i < sqlParamaters.length; i++) {
    //             objectWrapper.subNames.push(sqlParamaters[i].nm)
    //         }
    //     }
    // }

    // packSubNames(objectWrapper, lAttributes) {
    //     objectWrapper.subNames = [];

    //     for (let i = 0; i < lAttributes.length; i++) {
    //         objectWrapper.subNames.push(lAttributes[i].lAttrNm.toUpperCase());
    //     }
    // }

    // packSubNames(splitterWrapper, splt_Inst_Cnds) {
    //     splitterWrapper.subNames = [];

    //     for (let i = 0; i < splt_Inst_Cnds.length; i++) {
    //         splitterWrapper.subNames.push(splt_Inst_Cnds[i].spltCndNm)
    //     }
    // }

    cloneParameter(parameter) {
        if (!parameter) return;

        //				let parameterNew = angular.copy(parameter);
        //				
        //				parameterNew.param_Id = parameter.param_Id;
        //				parameterNew.nm = parameter.nm;
        //				parameterNew.paramNm = parameter.paramNm;
        //				parameterNew.paramDTyp_Id = parameter.paramDTyp_Id;
        //				parameterNew.paramScale = parameter.paramScale;
        //				parameterNew.paramPrec = parameter.paramPrec ;

        return parameter;
    }

    addParameterAt(parameter, parameters, index, objectWrapper) {
        if (index == -1) {
            return;
        }

        objectWrapper.sqlParams.splice(index, 0, parameter);

        // resetParametersSrt_Order(parameters, index);

        if (objectWrapper.subNames.indexOf(parameter.paramNm) == -1)
            objectWrapper.subNames.push(parameter.paramNm);
    }

    /*addSqlParameterAt( parameter, parameters, index, objectWrapper ) {
        if( index == -1 ) {
            return;
        }
        if(parameter.paramTyp == "P"){
            objectWrapper.designParams.splice( index, 0, parameter );
        }else{
            objectWrapper.sqlParams.splice( index, 0, parameter );
        }
    	
        resetParametersSrt_Order( parameters, index );
    	
        if( objectWrapper.subNames.indexOf(parameter.nm) == -1 )
            objectWrapper.subNames.push(parameter.nm);
    }*/


    /******************** SPLT_INST_CNDS - SPLITTER  ****************/
    splt_Inst_CndEmpty = null;



    upSplt_Inst_Cnds(selectedSplt_Inst_Cnds, splt_Inst_Cnds, objectWrapper) {

        for (let i = 0; i < selectedSplt_Inst_Cnds.length; i++) {
            let index = splt_Inst_Cnds.indexOf(selectedSplt_Inst_Cnds[i]);
            if (index <= 0) continue;

            let splicedSplt_Inst_Cnds = splt_Inst_Cnds.splice(index, 1);
            splt_Inst_Cnds.splice(index - 1, 0, splicedSplt_Inst_Cnds[0]);
        }

        // resetSplt_Inst_CndsSrt_Order(splt_Inst_Cnds);
    }

    downSplt_Inst_Cnds(selectedSplt_Inst_Cnds, splt_Inst_Cnds, objectWrapper) {
        for (let i = selectedSplt_Inst_Cnds.length - 1; i >= 0; i--) {
            let index = splt_Inst_Cnds.indexOf(selectedSplt_Inst_Cnds[i]);
            if (index == -1 || index == (splt_Inst_Cnds.length - 1)) continue;

            let splicedSplt_Inst_Cnds = splt_Inst_Cnds.splice(index, 1);
            splt_Inst_Cnds.splice(index + 1, 0, splicedSplt_Inst_Cnds[0]);
        }

        // resetSplt_Inst_CndsSrt_Order(splt_Inst_Cnds);
    }

    getImageIcon(objectWrapper) {

        if (!objectWrapper) return "";

        let reusableFlag = objectWrapper.reusableFlag == "Y" ? "G" : "";
        let localFlag = objectWrapper.localFlag == "Yes" ? "L" : "N";

        if (objectWrapper.databaseWrapper != undefined) {
            return "database-svg-icon/" + objectWrapper.databaseWrapper.dBName + "/" + reusableFlag + localFlag + "_" + objectWrapper.obj_Cd + objectWrapper.databaseWrapper.objCode + ".svg";
        }

        /*else {
            let reusable = objectWrapper.item.reusableFlag == "Y" ? "G" : "";
            let local = objectWrapper.item.localFlag == "Y" ? "L" : "N"; 
            return "database-svg-icon/"+objectWrapper.database.dBName+ "/" + reusable + local + "_" + objectWrapper.item.obj_Cd + objectWrapper.database.objCode + ".svg";
        }*/

    }
}